package co.uk.paxes.pinpoint.model

import kotlinx.serialization.Serializable

@Serializable
data class Pin(
    val color: PinColor,
    val originalColor: PinColor? = null, // The original pin color before being played as joker
    val isJoker: Boolean = false,
    val isReversed: Boolean = false,
    val isJokerTurnedBlack: Boolean = false
) {
    companion object {
        fun regular(color: PinColor) = Pin(color = color)
        fun joker(originalColor: PinColor, playedAsColor: PinColor) = Pin(
            color = playedAsColor, 
            originalColor = originalColor, 
            isJoker = true
        )
        fun dress(color: PinColor) = Pin(color = color) // Dress pins in center
    }
    
    /**
     * Get the effective color for scoring purposes
     */
    fun getEffectiveColor(): PinColor {
        return when {
            isReversed -> PinColor.BLACK // Inverted pins from line-of-6
            isJokerTurnedBlack -> PinColor.BLACK // Turned black after hand completion
            // For jokers, always use the color they were played as (stored in 'color' field)
            // even if they've turned black visually after hand completion
            else -> color
        }
    }
    
    /**
     * Create a reversed version of this pin
     */
    fun reversed(): Pin = copy(isReversed = true)
    
    /**
     * Turn joker black after hand completion (permanent)
     */
    fun turnJokerBlack(): Pin = if (isJoker) copy(isJokerTurnedBlack = true, color = PinColor.BLACK) else this
}
